import { apiClient } from '@/lib/api.ts'

export function getScoringConfig() {
  return apiClient.get('/acquisition/scoring-config')
}

export function saveScoringConfig(data: Record<string, unknown>) {
  return apiClient.post('/acquisition/scoring-config', data)
}

export function recalculateScoring() {
  return apiClient.post<{ updated: number }>('/acquisition/scoring-config/recalculate', {})
}

export function getGeoZones() {
  return apiClient.get('/acquisition/geo-zones')
}

export function createGeoZone(body: Record<string, unknown>) {
  return apiClient.post('/acquisition/geo-zones', body)
}

export function deleteGeoZone(id: string) {
  return apiClient.delete(`/acquisition/geo-zones/${id}`)
}

export function updateGeoZone(id: string, body: Record<string, unknown>) {
  return apiClient.patch(`/acquisition/geo-zones/${id}`, body)
}

export function getPainPoints() {
  return apiClient.get('/acquisition/pain-points')
}

export function generatePainPoints() {
  return apiClient.post('/acquisition/pain-points/generate', {})
}

export function togglePainPoint(id: string, isActive: boolean) {
  return apiClient.patch(`/acquisition/pain-points/${id}`, { isActive })
}

export function redistributeTasks() {
  return apiClient.post<{ prospectsUpdated: number; tasksUpdated: number }>('/acquisition/tasks/redistribute', {})
}
